import { z } from "zod";

import { Icon } from "@/client";
import i18n from "@/i18n";

const httpsUrlSchema = z
  .string()
  .url()
  .refine((url) => url.startsWith("https://"), {
    message: i18n.t("validation.httpsOnly"),
  });

const urlNavigationItemSchema = z.object({
  icon: z.nativeEnum(Icon),
  title: z
    .string()
    .min(1, { message: i18n.t("validation.navigationTitleRequired") })
    .trim(),
  visibility: z.string().optional(),
  url: httpsUrlSchema,
});

type UrlNavigationItemFormData = z.infer<typeof urlNavigationItemSchema>;

export { httpsUrlSchema, urlNavigationItemSchema };
export type { UrlNavigationItemFormData };
